import { render, staticRenderFns } from "./registerSuc.vue?vue&type=template&id=46831a91&scoped=true"
import script from "./registerSuc.vue?vue&type=script&lang=js"
export * from "./registerSuc.vue?vue&type=script&lang=js"
import style0 from "./registerSuc.vue?vue&type=style&index=0&id=46831a91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46831a91",
  null
  
)

export default component.exports